module.exports = __webpack_public_path__ + "static/img/connectIcon.d5267b8d.png";